// extracted by mini-css-extract-plugin
export default {"no-left-padding-wrap":"PageWrap_no-left-padding-wrap__X+frj","wrap":"PageWrap_wrap__SaFYV","cover":"PageWrap_cover__Et3qR"};